<template>
  <div class="ficha-mapa ficha-municipios">
    <div class="encabezado">Municipios</div>
    <div class="contenedor">
      <div class="col-1_3">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha2/1-Densidad de poblacion.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Asentamientos urbanos</p>
          </div>
          <div class="ficha-titulo">
            <h4>Población</h4>
          </div>
          <div class="ficha-cuerpo">
            <ul class="m-t-0-md">
              <li>
                El área de estudio de la población afectada se delimitó a las
                siguientes delegaciones y municipios de la Ciudad de México y
                del Estado de México: Venustiano Carranza, Gustavo A. Madero,
                Ecatepec, Acolman, Tezoyuca, Atenco, Texcoco, Chimalhuacán y
                Nezahualcóyotl.
              </li>
              <li>
                Las localidades urbanas ocupan 54,814.5 ha (52.92 % de la
                superficie total), mientras que las poblaciones rurales, 2,628.63 ha, es decir, 2.54% de la superficie total de la región
                de estudio.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col-2_3">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha2/2-Densidad de poblacion.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Vista de Ixtapaluca</p>
          </div>
          <div class="ficha-titulo">
            <h4>Urbanización</h4>
          </div>
          <div class="ficha-cuerpo">
            <div class="contenedor">
              <ul class="col-2 m-t-0-md">
                <li>
                  En ocho de los 29 municipios analizados, el crecimiento urbano
                  ha rebasado el área urbana disponible y nueve ocupan casi la
                  totalidad del área prevista para asentamientos en los
                  programas y planes de desarrollo urbano analizados.
                </li>
                <li>
                  En general, algunos municipios de la Cuenca de Texcoco y de la
                  zona de influencia del PELT presentaron los valores más altos
                  de densidad urbana, incremento de densidad urbanizable y
                  asentamientos irregulares.
                </li>
              </ul>
              <ul class="col-2 m-t-0">
                <li>
                  Los municipios que presentan la mayor superficie de
                  asentamientos irregulares, ubicados en la Cuenca en 2020, son
                  Texcoco, Chalco, La Paz, Ixtapaluca, Chimalhuacán,
                  Temascalapa, Tezoyuca.
                </li>
                <li>
                  La mayoría del área urbana actual se encuentra en terrenos con
                  dificultades para su urbanización por las características del
                  suelo y sus pendientes.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Municipios",
};
</script>
